module.exports = __webpack_public_path__ + "img/youth-reader.79fdbad0.png";